import { render, staticRenderFns } from "./IncomeChart.vue?vue&type=template&id=51848ffa&scoped=true&"
import script from "./IncomeChart.vue?vue&type=script&lang=js&"
export * from "./IncomeChart.vue?vue&type=script&lang=js&"
import style0 from "./IncomeChart.vue?vue&type=style&index=0&id=51848ffa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51848ffa",
  null
  
)

export default component.exports